import React, { useState, useContext, useEffect } from "react";

import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import { DispatchContext as HomeDispatchContext } from "bodycodi/cmap/app/components/cmap2010/home";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";
import Member from "bodycodi/cmap/app/components/common/Member";

type MemberListProp = {
  memberList: any;
};

const MemberListWrap = () => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (state.showCommunityMemberList?.length > 1) {
      setTitle(
        state.showCommunityMemberList[0]?.name +
          "님 외 " +
          (state.showCommunityMemberList?.length - 1) +
          "명"
      );
    } else {
      setTitle(state.showCommunityMemberList[0]?.name + "님");
    }
  }, [state.showCommunityMemberList]);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "COMUNITY_MEMBER_LIST_POP",
      open: { comunityMemberListPop: false },
    });
  };

  return (
    <CustomDialog open={state.comunityMemberListPop} onClose={handleClose}>
      <PopupHeader onClickBack={handleClose} title={title} />
      <MemberList memberList={state.showCommunityMemberList} />
    </CustomDialog>
  );
};

const MemberList = ({ memberList }: MemberListProp) => {
  const { dispatch: homeDispatch } = useContext(HomeDispatchContext);
  const { dispatch } = useContext(DispatchContext);

  const clickMember = (d: any) => () => {
    homeDispatch({
      type: "UPDATE",
      data: {
        memberDtlPopData: {
          seqPartner: d.seqPartner,
          seqPartnerBranch: d.seqPartnerBranch,
          seqMember: d.seqMember,
        },
      },
    });
    dispatch({ type: "POP_UP_OPEN", id: "MEMBER_DTL_POP", open: { memberDtlPop: true } });
  };

  return (
    <div>
      {memberList.map((d: any) => (
        <Member
          key={d.seqMember}
          d={d}
          from="management"
          isChecked={false}
          onClickMember={clickMember(d)}
        />
      ))}
    </div>
  );
};

export default MemberListWrap;
